// extracted by mini-css-extract-plugin
export default {"pagination_wrapper":"PaginationBar_pagination_wrapper__yEXDp","right":"PaginationBar_right__BaWEN","page_size_selectbox":"PaginationBar_page_size_selectbox__5CL10"};